import type { Page } from '@shared/types/Tilelist';
import type { IntentResult } from '@shared/types/types.ts';
import { isInterleavedIntent, isRankedIntent } from '@shared/types/types.ts';
import type { GalleryLayout } from '@tilelist/domain/composition/GalleryLayout.ts';

/**
 *
 *
 *
 */
export function getRankedPaging(
    intents: IntentResult[],
    layout: GalleryLayout,
    comparisonId: string | undefined,
): Page {
    const primaryIntent = intents.find(isInterleavedIntent) ?? intents.find(isRankedIntent);
    const primaryMeta = primaryIntent?.meta;

    return {
        sortiertnach: primaryMeta?.sortOrder ?? '',
        o: primaryMeta?.offset?.toString() ?? '',
        l: layout.layoutParam,
        c: comparisonId ?? '',
    };
}
